// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Sidebar Container ===== */
.sidebar {
  height: calc(100vh - 42px);
  width: 240px;
  position: fixed;
  top: 10px;
  left: 20px;
  background: rgba(10, 15, 36, 0.6); /* Semi-transparent for glass effect */
  padding: 10px 0;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: width 0.4s ease-in-out, background 0.4s ease-in-out;
  border: 2px solid rgba(0, 230, 230, 0.3); /* Subtle neon border */
  box-shadow: 0 0 15px rgba(0, 230, 230, 0.2);
  backdrop-filter: blur(10px); /* Glass effect */
  z-index: 1000;
  animation: neonPulse 3s infinite alternate ease-in-out; /* Subtle glow */
}

@keyframes neonPulse {
  from {
    box-shadow: 0 0 15px rgba(0, 230, 230, 0.2);
  }
  to {
    box-shadow: 0 0 25px rgba(0, 230, 230, 0.8);
  }
}

.sidebar.collapsed {
  width: 80px;
  box-shadow: none;
  transition: all 0.5s ease-in-out;
}

/* ===== Sidebar Header ===== */
.sidebar-header {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: relative;
  padding-bottom: 10px;
}

.sidebar-header img {
  width: 70px;
  height: 70px;
}

.sidebar-header span {
  color: #00e6e6;
  font-size: 18px;
  margin-left: 10px;
  font-weight: bold;
}

/* ===== Toggle Button (Sliding Effect) ===== */
.toggle-btn {
  background: none;
  border: none;
  cursor: pointer;
  position: absolute;
  right: -14px;
  top: 110%;
  transform: translateY(-50%);
  transition: transform 0.3s ease;
}

.toggle-btn img {
  width: 20px;
  height: 20px;
  transition: transform 0.3s ease;
}

.sidebar.collapsed .toggle-btn img {
  transform: rotate(180deg);
}

/* ===== Sidebar Menu ===== */
.sidebar-menu {
  color: #00e6e6;
  font-size: 18px;
  text-align: center;
  font-weight: 600;
  margin-bottom: 10px;
}

/* ===== Menu Items with Hover Glow Effect ===== */
.menu-items-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  color: #c0c0c0;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  border-radius: 5px;
  font-size: 16px;
  position: relative;
  overflow: hidden;
}

.menu-item:hover {
  background-color: rgba(0, 230, 230, 0.3);
  color: #00e6e6;
  text-shadow: 0px 0px 8px rgba(0, 230, 230, 0.8);
  box-shadow: 0 0 15px rgba(0, 230, 230, 0.5);
}

.menu-item a {
  text-decoration: none;
  color: inherit;
  display: flex;
  align-items: center;
  width: 100%;
  gap: 5px;
}

/* ===== Active (Selected) Tab with Neon Trail ===== */
.menu-item.selected {
  background: linear-gradient(90deg, rgba(0, 230, 230, 0.4), rgba(0, 100, 255, 0.4));
  color: white;
  font-weight: bold;
  border-radius: 6px;
  transition: background-color 0.3s ease, color 0.3s ease;
  box-shadow: 0 0 20px rgba(0, 230, 230, 0.5);
}

.menu-item.selected a {
  color: white !important;
}

.menu-item.selected:hover {
  background-color: rgba(0, 230, 230, 0.6);
}

/* ===== Logout Button ===== */
.logout-button {
  text-decoration: none;
  color: #ff4d4d;
  display: flex;
  align-items: center;
  width: 100%;
  border: none;
  outline: none;
  font-size: 16px;
  background: transparent;
  gap: 5px;
  transition: all 0.3s ease;
}

.logout-button:hover {
  background: rgba(255, 77, 77, 0.2);
  color: white;
  box-shadow: 0px 0px 8px rgba(255, 77, 77, 0.8);
}

/* ===== Sub-menu Styling ===== */
.sub-menu .menu-item {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  color: #c0c0c0;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  border-radius: 5px;
  font-size: 16px;
  margin-top: 8px;
}

.sub-menu .menu-item:hover {
  background-color: rgba(0, 230, 230, 0.3);
  color: #00e6e6;
}

.sub-menu .menu-item.selected {
  background-color: rgba(0, 230, 230, 0.5);
  color: white;
}

.sub-menu {
  margin-top: 10px;
  padding-left: 20px;
  background-color: rgba(15, 15, 36, 0.6);
  border-radius: 5px;
}

/* ===== Collapsed Sidebar Slide Effect ===== */
.sidebar.collapsed .sidebar-header span,
.sidebar.collapsed .menu-item span {
  display: none;
}

.sidebar.collapsed {
  width: 80px;
  transition: all 0.5s ease-in-out;
}

/* ===== NOTAM Special Animation (Futuristic Typing Effect) ===== */
@keyframes typewriter {
  from { width: 0; }
  to { width: 100%; }
}

@keyframes blink-caret {
  from, to { border-color: transparent; }
  50% { border-color: #00e6e6; }
}

.menu-item.notam span {
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  border-right: 2px solid #00e6e6;
  width: 0;
  animation: typewriter 3s steps(10, end) forwards, blink-caret 0.6s step-end infinite;
}
`, "",{"version":3,"sources":["webpack://./src/styles/sidebar.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;EACE,0BAA0B;EAC1B,YAAY;EACZ,eAAe;EACf,SAAS;EACT,UAAU;EACV,iCAAiC,EAAE,sCAAsC;EACzE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,+DAA+D;EAC/D,wCAAwC,EAAE,uBAAuB;EACjE,2CAA2C;EAC3C,2BAA2B,EAAE,iBAAiB;EAC9C,aAAa;EACb,sDAAsD,EAAE,gBAAgB;AAC1E;;AAEA;EACE;IACE,2CAA2C;EAC7C;EACA;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,+CAA+C;AAC/C;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,+CAA+C;EAC/C,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,QAAQ;AACV;;AAEA,sDAAsD;AACtD;EACE,kFAAkF;EAClF,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,uDAAuD;EACvD,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,8BAA8B;AAC9B;EACE,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,8CAA8C;AAChD;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA,+CAA+C;AAC/C;;EAEE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gCAAgC;AAClC;;AAEA,mEAAmE;AACnE;EACE,OAAO,QAAQ,EAAE;EACjB,KAAK,WAAW,EAAE;AACpB;;AAEA;EACE,WAAW,yBAAyB,EAAE;EACtC,MAAM,qBAAqB,EAAE;AAC/B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,QAAQ;EACR,oFAAoF;AACtF","sourcesContent":["/* ===== Sidebar Container ===== */\r\n.sidebar {\r\n  height: calc(100vh - 42px);\r\n  width: 240px;\r\n  position: fixed;\r\n  top: 10px;\r\n  left: 20px;\r\n  background: rgba(10, 15, 36, 0.6); /* Semi-transparent for glass effect */\r\n  padding: 10px 0;\r\n  border-radius: 10px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  transition: width 0.4s ease-in-out, background 0.4s ease-in-out;\r\n  border: 2px solid rgba(0, 230, 230, 0.3); /* Subtle neon border */\r\n  box-shadow: 0 0 15px rgba(0, 230, 230, 0.2);\r\n  backdrop-filter: blur(10px); /* Glass effect */\r\n  z-index: 1000;\r\n  animation: neonPulse 3s infinite alternate ease-in-out; /* Subtle glow */\r\n}\r\n\r\n@keyframes neonPulse {\r\n  from {\r\n    box-shadow: 0 0 15px rgba(0, 230, 230, 0.2);\r\n  }\r\n  to {\r\n    box-shadow: 0 0 25px rgba(0, 230, 230, 0.8);\r\n  }\r\n}\r\n\r\n.sidebar.collapsed {\r\n  width: 80px;\r\n  box-shadow: none;\r\n  transition: all 0.5s ease-in-out;\r\n}\r\n\r\n/* ===== Sidebar Header ===== */\r\n.sidebar-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 100%;\r\n  position: relative;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.sidebar-header img {\r\n  width: 70px;\r\n  height: 70px;\r\n}\r\n\r\n.sidebar-header span {\r\n  color: #00e6e6;\r\n  font-size: 18px;\r\n  margin-left: 10px;\r\n  font-weight: bold;\r\n}\r\n\r\n/* ===== Toggle Button (Sliding Effect) ===== */\r\n.toggle-btn {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  position: absolute;\r\n  right: -14px;\r\n  top: 110%;\r\n  transform: translateY(-50%);\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.toggle-btn img {\r\n  width: 20px;\r\n  height: 20px;\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.sidebar.collapsed .toggle-btn img {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n/* ===== Sidebar Menu ===== */\r\n.sidebar-menu {\r\n  color: #00e6e6;\r\n  font-size: 18px;\r\n  text-align: center;\r\n  font-weight: 600;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n/* ===== Menu Items with Hover Glow Effect ===== */\r\n.menu-items-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n}\r\n\r\n.menu-item {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 12px 20px;\r\n  color: #c0c0c0;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease-in-out;\r\n  border-radius: 5px;\r\n  font-size: 16px;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.menu-item:hover {\r\n  background-color: rgba(0, 230, 230, 0.3);\r\n  color: #00e6e6;\r\n  text-shadow: 0px 0px 8px rgba(0, 230, 230, 0.8);\r\n  box-shadow: 0 0 15px rgba(0, 230, 230, 0.5);\r\n}\r\n\r\n.menu-item a {\r\n  text-decoration: none;\r\n  color: inherit;\r\n  display: flex;\r\n  align-items: center;\r\n  width: 100%;\r\n  gap: 5px;\r\n}\r\n\r\n/* ===== Active (Selected) Tab with Neon Trail ===== */\r\n.menu-item.selected {\r\n  background: linear-gradient(90deg, rgba(0, 230, 230, 0.4), rgba(0, 100, 255, 0.4));\r\n  color: white;\r\n  font-weight: bold;\r\n  border-radius: 6px;\r\n  transition: background-color 0.3s ease, color 0.3s ease;\r\n  box-shadow: 0 0 20px rgba(0, 230, 230, 0.5);\r\n}\r\n\r\n.menu-item.selected a {\r\n  color: white !important;\r\n}\r\n\r\n.menu-item.selected:hover {\r\n  background-color: rgba(0, 230, 230, 0.6);\r\n}\r\n\r\n/* ===== Logout Button ===== */\r\n.logout-button {\r\n  text-decoration: none;\r\n  color: #ff4d4d;\r\n  display: flex;\r\n  align-items: center;\r\n  width: 100%;\r\n  border: none;\r\n  outline: none;\r\n  font-size: 16px;\r\n  background: transparent;\r\n  gap: 5px;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.logout-button:hover {\r\n  background: rgba(255, 77, 77, 0.2);\r\n  color: white;\r\n  box-shadow: 0px 0px 8px rgba(255, 77, 77, 0.8);\r\n}\r\n\r\n/* ===== Sub-menu Styling ===== */\r\n.sub-menu .menu-item {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 12px 20px;\r\n  color: #c0c0c0;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease-in-out;\r\n  border-radius: 5px;\r\n  font-size: 16px;\r\n  margin-top: 8px;\r\n}\r\n\r\n.sub-menu .menu-item:hover {\r\n  background-color: rgba(0, 230, 230, 0.3);\r\n  color: #00e6e6;\r\n}\r\n\r\n.sub-menu .menu-item.selected {\r\n  background-color: rgba(0, 230, 230, 0.5);\r\n  color: white;\r\n}\r\n\r\n.sub-menu {\r\n  margin-top: 10px;\r\n  padding-left: 20px;\r\n  background-color: rgba(15, 15, 36, 0.6);\r\n  border-radius: 5px;\r\n}\r\n\r\n/* ===== Collapsed Sidebar Slide Effect ===== */\r\n.sidebar.collapsed .sidebar-header span,\r\n.sidebar.collapsed .menu-item span {\r\n  display: none;\r\n}\r\n\r\n.sidebar.collapsed {\r\n  width: 80px;\r\n  transition: all 0.5s ease-in-out;\r\n}\r\n\r\n/* ===== NOTAM Special Animation (Futuristic Typing Effect) ===== */\r\n@keyframes typewriter {\r\n  from { width: 0; }\r\n  to { width: 100%; }\r\n}\r\n\r\n@keyframes blink-caret {\r\n  from, to { border-color: transparent; }\r\n  50% { border-color: #00e6e6; }\r\n}\r\n\r\n.menu-item.notam span {\r\n  display: inline-block;\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  border-right: 2px solid #00e6e6;\r\n  width: 0;\r\n  animation: typewriter 3s steps(10, end) forwards, blink-caret 0.6s step-end infinite;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
